var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8481dd",
    d: "M2.27 12.412c0-1.999 1.193-3.716 2.684-3.716s2.684 1.717 2.684 3.716zM9.29.852H.619a.62.62 0 0 0-.619.62v.412c0 .342.277.62.62.62 0 2.347 1.316 4.328 3.117 4.954C1.936 8.084.62 10.065.62 12.412a.62.62 0 0 0-.619.62v.412c0 .342.277.62.62.62h8.669a.62.62 0 0 0 .62-.62v-.413a.62.62 0 0 0-.62-.62c0-2.346-1.316-4.327-3.118-4.953 1.802-.626 3.118-2.607 3.118-4.954a.62.62 0 0 0 .62-.62v-.413a.62.62 0 0 0-.62-.619z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInProgress);
export default __webpack_public_path__ + "static/media/icon_in_progress.41ed9abe.svg";
export { ForwardRef as ReactComponent };